import type { ElementType } from 'react';
import styled, { css, keyframes } from 'styled-components';

const pulsateKeyframes = keyframes({
  from: {
    transform: 'scale(1)',
    transformOrigin: 'center center',
    animationTimingFunction: 'ease-out',
  },

  '10%': {
    transform: 'scale(1.09)',
    animationTimingFunction: 'ease-in',
  },

  '17%': {
    transform: 'scale(1.02)',
    animationTimingFunction: 'ease-out',
  },

  '33%': {
    transform: 'scale(1.13)',
    animationTimingFunction: 'ease-in',
  },

  '45%': {
    transform: 'scale(1)',
    animationTimingFunction: 'ease-out',
  },
});

interface WithPulsateAnimationProps {
  $animate?: boolean;
}

const withPulsateAnimation = (Component: ElementType) =>
  styled(Component)<WithPulsateAnimationProps>(
    ({ $animate }) => css`
      animation: ${$animate ? pulsateKeyframes : 'none'} 3s ease-in-out infinite both;
    `,
  );

export const ButtonWrapper = withPulsateAnimation(styled.div({}));
